import React from "react";
import { PageNewState, ConfirmationWithCommentDialogInitialState } from ".";

export const ConfirmationWithCommentDialogContext = React.createContext({
  pageState: ConfirmationWithCommentDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
